import findIndex from 'lodash/findIndex';
import {
    START_CHECK_IP_AUTHENTICATION,
    COMPLETE_CHECK_IP_AUTHENTICATION,
    GET_IP_AUTHENTICATION_INFO,
    START_ADOBEPASS_INITIALIZE,
    COMPLETE_ADOBEPASS_INITIALIZE,
    START_CHECK_AUTHENTICATION,
    COMPLETE_CHECK_AUTHENTICATION,
    START_AUTHENTICATION,
    COMPLETE_AUTHENTICATION,
    START_AUTHORIZATION,
    COMPLETE_AUTHORIZATION,
    COMPLETE_LOGOUT,
    GET_AUTHENTICATION_INFO,
    GET_METADATA,
    COMPLETE_PREAUTH_CHECK,
    GET_LOCATION
} from '../actions/authenticationActions';

export function addAuthType(authTypes, authType) {
    // don't add multiple authtypes
    if (authTypes.indexOf(authType) !== -1) {
        return [...authTypes];
    }

    return [...authTypes, authType];
}

export function removeAuthType(authTypes, authType) {
    const index = authTypes.indexOf(authType);
    if (index === -1) {
        return [...authTypes];
    }
    return [
        ...authTypes.slice(0, index),
        ...authTypes.slice(index + 1)
    ];
}

export function authTypesReducer(state = [], action) {
    let authTypes = removeAuthType(state, `unknown_${action.authType}`);

    if (action.directive === 'add') {
        authTypes = addAuthType(authTypes, action.authType);
    } else {
        authTypes = removeAuthType(authTypes, action.authType);
    }
    return authTypes;
}

export function ipReducer(state = {}, action) {
    switch (action.type) {
        case START_CHECK_IP_AUTHENTICATION:
            return Object.assign({}, state, {
                initialization: {
                    initializing: true,
                    startTime: action.startTime
                }
            });
        case COMPLETE_CHECK_IP_AUTHENTICATION:
            return Object.assign({}, state, {
                initialization: {
                    initializing: false,
                    completeTime: action.completeTime
                }
            });
        case GET_IP_AUTHENTICATION_INFO:
            return Object.assign({}, state, {
                info: action.info
            });
        case GET_LOCATION:
            return Object.assign({}, state, {
                location: action.location
            });
        default:
            return state;
    }
}

export function adobePassReducer(state = {}, action) {
    switch (action.type) {
        case START_ADOBEPASS_INITIALIZE:
            return Object.assign({}, state, {
                initialization: {
                    initializing: true,
                    startTime: action.startTime
                }
            });
        case COMPLETE_ADOBEPASS_INITIALIZE:
            return Object.assign({}, state, {
                initialization: {
                    initializing: false,
                    completeTime: action.completeTime
                }
            });
        case START_CHECK_AUTHENTICATION:
            return Object.assign({}, state, {
                checkAuthentication: {
                    checkingAuthentication: true,
                    startTime: action.startTime
                }
            });
        case COMPLETE_CHECK_AUTHENTICATION:
            return Object.assign({}, state, {
                checkAuthentication: {
                    checkingAuthentication: false,
                    mvpd: action.mvpd,
                    completeTime: action.completeTime
                },
                isAuthenticated: action.isAuthenticated
            });
        case START_AUTHENTICATION:
            return Object.assign({}, state, {
                authentication: Object.assign({}, state.authentication, {
                    authenticating: true,
                    startTime: action.startTime
                })
            });
        case COMPLETE_AUTHENTICATION:
            return Object.assign({}, state, {
                authentication: Object.assign({}, state.authentication, {
                    authenticating: false,
                    mvpd: action.mvpd,
                    completeTime: action.completeTime
                }),
                isAuthenticated: action.isAuthenticated
            });
        case START_AUTHORIZATION:
            return Object.assign({}, state, {
                authorization: {
                    authorizing: true,
                    resourceId: action.resourceId,
                    startTime: action.startTime
                }
            });
        case COMPLETE_AUTHORIZATION:
            return Object.assign({}, state, {
                authorization: {
                    authorizing: false,
                    resourceId: action.resourceId,
                    token: action.token,
                    completeTime: action.completeTime
                },
                isAuthorized: ((action.token && (action.token.length > 0)) &&
                (action.resourceId && action.resourceId.length > 0)) || false
            });
        case COMPLETE_LOGOUT:
            return Object.assign({}, state, {
                info: {},
                isAuthenticated: false
            });
        case GET_AUTHENTICATION_INFO:
            return Object.assign({}, state, {
                info: action.info
            });
        case GET_METADATA: {
            const newMetaData = {};
            if (typeof action.key === 'string') {
                newMetaData[action.key] = action.value;
            }
            return Object.assign({}, state, {
                metadata: Object.assign({}, state.metadata, {
                    [action.key]: action.value
                })
            });
        }
        case COMPLETE_PREAUTH_CHECK: {
            const preauthorizedResources = state.preauthorizedResources ? state.preauthorizedResources.slice(0) : [];
            const resourceIndex = findIndex(preauthorizedResources, (res) => (res.adobeId === action.adobeId));
            const newResource = { adobeId: action.adobeId, preauthorized: action.preauthorized };
            if (resourceIndex === -1) {
                preauthorizedResources.push(newResource);
            } else {
                preauthorizedResources[resourceIndex] = newResource;
            }

            return Object.assign({}, state, {
                preauthorizedResources
            });
        }

        default:
            return state;
    }
}

export default function authenticationReducer(state = { authTypes: ['unknown_mvpd', 'unknown_isp'] }, action) {
    switch (action.type) {
        case START_CHECK_IP_AUTHENTICATION:
        case GET_LOCATION:
        case GET_IP_AUTHENTICATION_INFO:
            return Object.assign({}, state, {
                ip: ipReducer(state.ip, action)
            });
        case COMPLETE_CHECK_IP_AUTHENTICATION:
            return Object.assign({}, state, {
                ip: ipReducer(state.ip, action),
                authTypes: authTypesReducer(state.authTypes, action)
            });
        case START_ADOBEPASS_INITIALIZE:
        case COMPLETE_ADOBEPASS_INITIALIZE:
        case START_CHECK_AUTHENTICATION:
        case START_AUTHENTICATION:
        case START_AUTHORIZATION:
        case COMPLETE_AUTHORIZATION:
        case GET_AUTHENTICATION_INFO:
        case GET_METADATA:
        case COMPLETE_PREAUTH_CHECK:
            return Object.assign({}, state, {
                adobePass: adobePassReducer(state.adobePass, action)
            });
        case COMPLETE_CHECK_AUTHENTICATION:
        case COMPLETE_AUTHENTICATION:
        case COMPLETE_LOGOUT:
            return Object.assign({}, state, {
                adobePass: adobePassReducer(state.adobePass, action),
                authTypes: authTypesReducer(state.authTypes, action)
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./app/common/reducers/authenticationReducer.js